import { notNullFilter } from "../../features/dataFunctions/dataFunctions"
import { getItemWebStorage, setItemWebStorage } from "../../features/webStorageSaver"
import { setDatabaseOptions, setIdsOfPathsWithGeometry, setPathsList, setRoadRaionSegments, setRoadsList } from "../../stateManagement/reducers"
import { store } from "../../stateManagement/store"

export function configureDatabaseSelectOptions(databaseUrlPrefix: any) {
    const fullConfig = store.getState().config.fullConfig
    let databaseSelectOptions = Object.entries(fullConfig).map(([prefix, config]: any) => {
        const { selectable, company: name } = config
        if (selectable) {
            return { prefix, name }
        }
    }).filter(notNullFilter)
    if (databaseUrlPrefix) {
        const filteredDatabaseSelectOptions = databaseSelectOptions.filter((databaseOption: any) => databaseOption.prefix === databaseUrlPrefix)
        if (filteredDatabaseSelectOptions.length > 0) {
            databaseSelectOptions = filteredDatabaseSelectOptions
        }
    }
    databaseSelectOptions.sort((a, b) => a?.name.localeCompare(b?.name))
    store.dispatch(setDatabaseOptions(databaseSelectOptions))
}

export async function getRoads(fetchRoadsFunction: any) {
    const { data } = await fetchRoadsFunction({})
    const roadsList = data?.value
    if (roadsList) {
        const light = roadsList.map(({ Name, Id }: any) => ({ Name, Id }))
        store.dispatch(setRoadsList(light))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, roadsList: light }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }
}

export async function getRoadRaionSegments(fetchRoadRaionSegmentsFunction: any) {
    const { roadListIsGroupedByRaions } = getItemWebStorage('currentConfig') ?? {};
    if (roadListIsGroupedByRaions) {
        const { data } = await fetchRoadRaionSegmentsFunction({})
        const roadRaionSegments = data?.value
        if (roadRaionSegments) {
            const light = roadRaionSegments.map(({ PathID, RaionId, RaionName }: any) => ({ PathID, RaionId, RaionName }))
            store.dispatch(setRoadRaionSegments(light))
            const localPathsInfo = getItemWebStorage('pathsInfo')
            const newPathsInfo = { ...localPathsInfo, roadRaionSegments: light }
            setItemWebStorage('pathsInfo', newPathsInfo)
        }
    }
}

export async function getPaths(fetchPathsFunction: any) {
    const { data } = await fetchPathsFunction({})
    const pathsList = data?.value
    if (pathsList) {
        const light = pathsList.map(({ Name, RoadName, PathID, RoadId }: any) => ({ Name, RoadName, PathID, RoadId }))
        store.dispatch(setPathsList(light))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, pathsList: light }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }
}

export async function getIdsOfPathsWithGeometry(fetchIdsOfPathsWithGeometryFunction: any) {
    const { data: idsOfPathsWithGeometry } = await fetchIdsOfPathsWithGeometryFunction({})
    if (idsOfPathsWithGeometry) {
        store.dispatch(setIdsOfPathsWithGeometry(idsOfPathsWithGeometry))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, idsOfPathsWithGeometry }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }
}

// функция для запроса на получения списка всех типов объектов
export async function getObjectTypes(fetchObjectTypesStructureFunction: any, token: any) {
    const { data: objectTypesStructure } = await fetchObjectTypesStructureFunction({ token })
    setItemWebStorage('objectTypesStructure', objectTypesStructure)
    const objectTypes = configureObjectTypesList(objectTypesStructure).filter(notNullFilter)
    setItemWebStorage('objectTypes', objectTypes)
}

// функция для запроса на получения списка всех типов объектов
export async function getAddressTypes(fetchAddressTypesFunction: any) {
    const { data: addressTypes } = await fetchAddressTypesFunction({})
    setItemWebStorage('addressTypes', addressTypes)
}

// функция для получения массива названий всех типов объектов
export function configureObjectTypesList(items: any) {
    let results: any = [];
    items.forEach((item: any) => {
        if (item.UrlUrl || item.url) {
            let name = item.UrlUrl ?? item.url.split('/')[1]
            let objectTypeParameters = {
                name,
                caption: item.Caption,
                captionSingular: item.CaptionSingular,
                classId: item.ClassId,
                imageIndex: item.ImageIndex,
                mapLayer: item.mapLayer,
                queryType: item.queryType
            }
            results.push(objectTypeParameters)
        }
        if (item.Types) {
            const childResults = configureObjectTypesList(item.Types);
            results = [...results, ...childResults];
        }
    });
    return results;
}